import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classes from './OfferCard.scss';

import { offerOptions } from './OfferCard'
import { offerOptions as couponOptions } from '../coupons/CouponCard'
import OfferOptions from 'cityads-v3/components/OfferOptions/OfferOptions'
import Skeleton from '@mui/material/Skeleton'

import { ACTION_TYPE_DIRECTION_ID_API } from 'cityads-v3/reducers/offers'

const SKELETON_OPTIONS_COUNT = 3;

export default function OfferCardOptions({offer, isCoupon}) {
  const { t } = useTranslation(['Offers']);
  const offerStat = useSelector(state => state.offers.offerStatByOfferId[offer?.id] ?? {});

  const promoActionTypesById = useSelector(state => state.offers.promoActionTypesById[offer?.promo_action_type]);
  const promoCouponScopesById = useSelector(state => state.offers.promoCouponScopesById[offer?.promo_coupon_scope]);
  const promoCouponStatusesById = useSelector(state => state.offers.promoCouponStatusesById);
  const promoCouponLanguagesById = useSelector(state => state.language.sadukaLanguagesById);

  const { action_type_direction_id, status} = offer ?? {};
  const { cr_is_expected, leadbased_is_expected } = offerStat;

  const options = isCoupon ?
    couponOptions(t, {
      ...offer,
      promoActionTypesById,
      promoCouponScopesById,
      promoCouponStatusesById,
      promoCouponLanguagesById,
      linkSource: 'coupons'
    })
    :
    offerOptions(t, {
      isApi: Number(action_type_direction_id) === ACTION_TYPE_DIRECTION_ID_API,
      status: status,
      crIsExpected: cr_is_expected,
      leadbasedIsExpected: leadbased_is_expected,
    })

  return offer ? (
    <OfferOptions
      className={classes.options}
      options={options}
      offerInfo={offer}
      offerStat={offerStat}
    />
  ) :
    <>
      {Array(SKELETON_OPTIONS_COUNT).fill(null).map((_, idx) => (
        <Skeleton
          key={idx}
          animation="wave"
          variant="rectangular"
          width={80}
          height={48}
          style={{
            display: 'inline-block',
            margin: '16px 20px 0 16px'
          }}/>
      ))}
    </>
}

OfferCardOptions.propTypes = {
  offer: PropTypes.object,
  isCoupon: PropTypes.bool
}
